import { useHandler } from "@redotech/react-util/hook";
import { useTranslation } from "@redotech/redo-i18n";
import {
  RedoModal,
  RedoModalButtonProps,
} from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";

export const RerunAutomationsModal = memo(function RerunAutomationsModal({
  isOpen,
  onClose,
  onConfirm,
  isAllUnfulfilled,
  numAutomations,
  numUnfulfilledGroups,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isAllUnfulfilled: boolean;
  numAutomations: number | undefined;
  numUnfulfilledGroups: number | undefined;
}) {
  const { t } = useTranslation();
  const [automationsTriggered, setAutomationsTriggered] = useState(false);
  const handleRerunAutomations = useHandler(async () => {
    setAutomationsTriggered(true);
    await onConfirm();
    setAutomationsTriggered(false);
    onClose();
  });

  const primaryButton: RedoModalButtonProps = {
    text: t("Rerun Automations"),
    onClick: handleRerunAutomations,
    pending: automationsTriggered,
  };

  const secondaryButton: RedoModalButtonProps = {
    text: t("Cancel"),
    onClick: onClose,
    disabled: automationsTriggered,
    pending: false,
  };

  return (
    <RedoModal
      buttonPlacement="tight"
      isOpen={isOpen}
      onModalCloseRequested={onClose}
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
      title={t("Rerun all automations")}
    >
      <Flex dir="column" gap="xl">
        <Text fontSize="sm" textColor="primary">
          This will rerun all of your automations
          {numAutomations ? ` (${numAutomations})` : ""} on
          {isAllUnfulfilled
            ? " all of your unfulfilled orders "
            : " your selected orders "}
          ({numUnfulfilledGroups}). This process may refresh rates and take a
          few minutes to complete.
        </Text>
      </Flex>
    </RedoModal>
  );
});
